<footer id="footer-container">
  <ng-container [ngTemplateOutlet]="customTemplate" [ngTemplateOutletContext]="listOfVariables"></ng-container>
  <ng-container *ngIf="!customTemplate">
    <ng-container *ngIf="emailSubscriptionSignupEnabled || channel.commsConsumerSignup">
      <div id="footer-subscribe-form">
        <ush-showtime-streaming-subscribe [type]="'all'"></ush-showtime-streaming-subscribe>
      </div>
    </ng-container>
    <div class="footer-wrapper" [ngClass]="{ 'transparent-background': transparentBackground }">
      <!-- Needed for script ActiveCampaign form -->
      <div #formActiveCampaign class="_form_22 isolated-from-movie-site"></div>

      <div id="footer" class="p-grid">
        <div class="social-footer">
          <div class="footer-logo">
            <a routerLink="/home" class="nav-logo nav-link">
              <img [src]="logoUrl | img: { height: 70 }" alt="logo" class="footer-icon" />
            </a>
          </div>

          <div class="footer-contact-info">
            <div class="footer-adress">
              <p>Lincoln, 11</p>
              <p>Barcelona (Barcelona) 08006, España</p>
            </div>
            <div class="contact-info-detail">
              <p>Teléfono: (+34) 93 539 85 36</p>
              <p>Email: info&#64;acontracorrientefilms.com</p>
            </div>
          </div>

          <ush-social-links
            *ngIf="hasSocialLinks && socialLinks.length > 0"
            [socialNetworks]="socialLinks"
          ></ush-social-links>
        </div>

        <div class="links-footer">
          <ng-container *ngIf="links.length > 0">
            <div class="footer-menu-wrap">
              <ul class="footer-menu">
                <li *ngFor="let link of links" (click)="onFooterLinkClicked(link)">
                  <a *ngIf="link.isExternal" href="{{ link.link }}" target="_blank">
                    {{ link.name | cammelCase | footerLocalize: link.name }}
                    <div class="border"></div>
                  </a>
                  <a *ngIf="!link.isExternal" routerLink="{{ link.link }}">
                    {{ link.name | cammelCase | footerLocalize: link.name }}
                    <div class="border"></div>
                  </a>
                </li>
                <!-- footer custom link -->
                <ng-container *ngIf="footerCustomLinkTemplate">
                  <ng-container
                    [ngTemplateOutlet]="footerCustomLinkTemplate"
                    [ngTemplateOutletContext]="{ $implicit: footerInstance }"
                  ></ng-container>
                </ng-container>
              </ul>
            </div>
          </ng-container>

          <ng-container *ngIf="copyrightMsg">
            <div class="copyright">
              {{ copyrightMsg }}
            </div>
          </ng-container>
          <ng-container *ngIf="hasTranslationFooter">
            <ush-language-selector></ush-language-selector>
          </ng-container>
        </div>

        <div class="bottom-footer" [class.has-footer-accreditations-stack]="showGeneralitatFooterLogo">
          <ng-container *ngIf="showGeneralitatFooterLogo; else footerAccreditationsLogo">
            <div class="footer-accreditations">
              <img
                [src]="footerAccreditationsLogoUrl | img: { height: 50 }"
                alt="acontrafilms-footer-logos"
                class="footer-accreditations-primary"
              />
              <img
                [src]="generalitatFooterLogoUrl"
                alt="Generalitat de Catalunya"
                class="footer-accreditations-secondary"
              />
            </div>
          </ng-container>
          <ng-template #footerAccreditationsLogo>
            <img [src]="footerAccreditationsLogoUrl | img: { height: 50 }" alt="acontrafilms-footer-logos" />
          </ng-template>
          <ush-usheru-logo></ush-usheru-logo>
        </div>
        <!-- usheru logo -->

        <!-- end usheru logo -->
      </div>
    </div>
  </ng-container>
</footer>
